<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3 hide-on-print">
      <SimplePageHeader title="Commissions" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            icon="cloud_download"
            color="primary"
            text="Excel"
            :block="true"
            @click="handleExportToExcel"
          />
          <ButtonPrint
            class="mt-3"
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <CommissionReportFilters
        class="px-5 mb-sm-5"
        @search="handleSearch"
        @clear="handleSearch"
      ></CommissionReportFilters>
    </div>
    <ReportHeader
      reportTitle="Commission Report"
      :reportCriteria="reportFilterCriteria"
    ></ReportHeader>
    <v-row>
      <v-col cols="12">
        <CommissionReportItemsTable
          class="px-0 pt-2"
          :commissionReportItems="commissionReportItems"
        />
      </v-col>
    </v-row>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import CommissionReportFilters from './CommissionReportFilters'
import { ButtonPrint, BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import ReportHeader from '@/components/reports/ReportHeader'
import CommissionReportItemsTable from './CommissionReportItemsTable'
import { SimplePageHeader } from '@/components/pageComponents'
import excel from '@/lib/export/excel'
import { progresModlaCommands } from '@/lib/progressModal'
import { formatCurrency } from '@/lib/display'

export default {
  mixins: [
    progresModlaCommands
  ],
  components: {
    CommissionReportFilters,
    ButtonPrint,
    BottomSpacer,
    ReportHeader,
    CommissionReportItemsTable,
    SimplePageHeader,
    ButtonCustomIcon
  },
  computed: {
    ...mapFields('commissionReport', [
      'commissionReportItems'
    ]),
    ...mapFields('commissionReportFilters', [
      'month',
      'year'
    ]),
    reportFilterCriteria: {
      get () {
        let months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
        return [
          { 'key': 'Month', 'value': months[parseInt(this.month) - 1] + ' - ' + parseInt(this.year) }
        ]
      }
    }
  },
  methods: {
    ...mapActions('commissionReport', [
      'getCommissionReportWithFilters'
    ]),
    handleSearch () {
      this.getCommissionReportWithFilters()
    },
    handleExportToExcel () {
      if (this.commissionReportItems && this.commissionReportItems.length > 0) {
        let data = []
        for (let item of this.commissionReportItems) {
          data.push({
            month: item.month,
            year: item.year,
            employeeName: item.employeeName,
            totalCommission: formatCurrency(item.totalCommission),
            totalIndividualGP: formatCurrency(item.totalIndividualGP),
            consultantsGP: formatCurrency(item.consultantsGP),
            permPlacementsGP: formatCurrency(item.permPlacementsGP),
            commissionOverride: formatCurrency(item.commissionOverride)
          })
        }
        let headers = ['Month', 'Year', 'Employee', 'Commission', 'Individual GP', 'Consultants GP', 'Perm. Placements GP', 'Override']
        let columns = ['month', 'year', 'employeeName', 'totalCommission', 'totalIndividualGP', 'consultantsGP', 'permPlacementsGP', 'commissionOverride']
        const params = {
          title: headers,
          key: columns,
          data: data,
          autoWidth: true,
          filename: `Commissions`
        }
        excel.exportArray2Excel(params)
      }
    }
  },
  created () {
    this.handleSearch()
  }
}
</script>
